import { useEffect, useState } from "react";
import {
 Box,
 Menu,
 FormGroup,
 MenuItem,
 IconButton,
 FormControlLabel,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { criticalFacilityToggleState } from "../../../../lib/Helpers/criticalFacilityState";
import { criticalFacilitiesAssetLayers } from "../../../../lib/Helpers/criticalFacilitiesURLs";
import "../Maps.css";

const ToggleCriticalFacilities = ({
 id,
 handleCriticalFacilityLayerChange,
 criticalAssetsEnabled,
 setCriticalAssetsEnabled,
 criticalFacilitiesLayers,
}) => {
 const [anchorEl, setAnchorEl] = useState(null);
 const [toggleSwitch, setToggleSwitch] = useState(false);
 const [checkedState, setCheckedState] = useState(criticalFacilityToggleState);

 const open = Boolean(anchorEl);

 useEffect(() => {
  for (let [facilityKey, isChecked] of Object.entries(checkedState)) {
   if (!!!toggleSwitch) {
    handleCriticalFacilityLayerChange(
     criticalFacilitiesLayers[facilityKey],
     false
    );
   } else {
    handleCriticalFacilityLayerChange(
     criticalFacilitiesLayers[facilityKey],
     !!isChecked
    );
   }
  }

  // set variable which prompts user for credentials
  // and generates a token to access layers
  if (!!!criticalAssetsEnabled && !!toggleSwitch) {
   setCriticalAssetsEnabled(true);
  } // should only happen once
 }, [toggleSwitch]);

 useEffect(() => {
  if (!!criticalAssetsEnabled) {
   for (let [facilityKey, isChecked] of Object.entries(checkedState)) {
    setCheckedState((prevState) => {
     prevState[facilityKey] = true;
     return { ...prevState };
    });
   }
   if (!!!toggleSwitch) setToggleSwitch(true);
  }
 }, [criticalAssetsEnabled]);

 const handleClick = (event) => {
  setAnchorEl(event.currentTarget);
 };
 const handleClose = () => {
  setAnchorEl(null);
 };

 const handleSetCheckedState = (stateKey, isChecked) => {
  setCheckedState((prevState) => {
   prevState[stateKey] = !!!isChecked;
   return { ...prevState };
  });
  handleCriticalFacilityLayerChange(
   criticalFacilitiesLayers[stateKey],
   !!!isChecked
  );
 };

 return (
  <Box
   id={id}
   className="critical-facilities-widget-container"
   sx={{
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    p: "0px 0px 0px 4px",
   }}
  >
   {/* 1. the switch component is used to toggle critical facilities layer(s) */}
   <FormGroup sx={{ ml: "12px" }}>
    <FormControlLabel
     sx={{
      color: `${!!toggleSwitch ? "#151515" : "#6e6e6e"}`,
      fontSize: "14px",
      lineHeight: "1.3em",
     }}
     control={
      <Switch
       sx={{ mr: 1 }}
       size="small"
       checked={toggleSwitch}
       onChange={() => {
        setToggleSwitch(!!!toggleSwitch);
       }}
       inputProps={{ "aria-label": "controlled" }}
      />
     }
     label="Critical Facilities"
    />
   </FormGroup>
   {/*  2. the dropdown component is used to toggle individual critical facilities layerview(s)  */}
   <IconButton
    size="small"
    id="basic-button"
    aria-controls={open ? "basic-menu" : undefined}
    aria-haspopup="true"
    aria-expanded={open ? "true" : undefined}
    onClick={handleClick}
   >
    <KeyboardArrowDownIcon />
   </IconButton>
   <Menu
    id="basic-menu"
    anchorEl={anchorEl}
    open={open}
    onClose={handleClose}
    sx={{ top: "8px", left: "3px" }}
    MenuListProps={{
     "aria-labelledby": "basic-button",
    }}
   >
    {Object.keys(criticalFacilityToggleState)?.map(
     (criticalFacilityKey, idx) => (
      <MenuItem key={`menu-item-${idx}`} size="small">
       <FormGroup>
        <FormControlLabel
         sx={{
          color: `${
           !!checkedState[criticalFacilityKey] ? "#151515" : "#6e6e6e"
          }`,
         }}
         control={
          <Checkbox
           size="small"
           checked={checkedState[criticalFacilityKey]}
           onChange={() => {
            handleSetCheckedState(
             criticalFacilityKey,
             checkedState[criticalFacilityKey]
            );
           }}
           inputProps={{ "aria-label": "controlled" }}
          />
         }
         label={`${
          criticalFacilitiesAssetLayers.find(
           (layer) => layer.stateVar === criticalFacilityKey
          )?.label
         }`}
        />
       </FormGroup>
      </MenuItem>
     )
    )}
   </Menu>
  </Box>
 );
};

export default ToggleCriticalFacilities;
